import { BrandName } from '../../windows-types';
import { DECEUNINCK_BRAND_STRUCTURE } from './deceuninck';
import { REHAU_BRAND_STRUCTURE } from './rehau';
import { VEKA_BRAND_STRUCTURE } from './veka';
import {
  DECEUNINCK_BRAND_REGION_LIST,
  REHAU_AND_DECEUNINCK_BRAND_REGION_LIST,
  REHAU_BRAND_REGION_LIST,
  VEKA_BRAND_REGION_LIST,
} from './windows-brands-section-constants';

export const getBrandConfig = (brandName: BrandName) => {
  switch (brandName) {
    case 'deceuninck':
      return DECEUNINCK_BRAND_STRUCTURE;
    case 'rehau':
      return REHAU_BRAND_STRUCTURE;
    case 'veka':
      return VEKA_BRAND_STRUCTURE;
    default:
      return undefined;
  }
};

export const getActiveBrandName = (regionId: string): BrandName | undefined => {
  if (
    DECEUNINCK_BRAND_REGION_LIST.includes(regionId) ||
    REHAU_AND_DECEUNINCK_BRAND_REGION_LIST.includes(regionId)
  ) {
    return 'deceuninck';
  }

  if (REHAU_BRAND_REGION_LIST.includes(regionId)) {
    return 'rehau';
  }

  if (VEKA_BRAND_REGION_LIST.includes(regionId)) {
    return 'veka';
  }

  return undefined;
};
